const fruit = 
[
    {
        "name": "Mango Sindhura",
        "weight": "1 kg (Approx. 6pcs - 7pcs)",
        "price": "₹  71 / 1 kg",
        "priceint": 71,
        "src": require("./Mango Sindhura.webp")
        },
        {
        "name": "Mango Alphonso Ratnagiri (Hapus)",
        "weight": "6 pcs (Approx. 1.2kg - 1.4kg)",
        "price": "₹  638 / 6 pcs",
        "priceint": 638,
        "src": require("./Mango Alphonso Ratnagiri (Hapus).webp")
        },
        {
        "name": "Mango Badami",
        "weight": "1 kg (Approx. 3pcs - 4pcs)",
        "price": "₹  192 / 1 kg",
        "priceint": 192,
        "src": require("./Mango Badami.webp")
        },
        {
        "name": "Mango Totapuri Raw",
        "weight": "1 kg (Approx. 4pcs - 5pcs)",
        "price": "₹  59 / 1 kg",
        "priceint": 59,
        "src": require("./Mango Totapuri Raw.webp")
        },
        {
        "name": "Litchi",
        "weight": "500 g",
        "price": "₹  234 / 500 g",
        "priceint": 234,
        "src": require("./Litchi.jpeg")
        },
        {
        "name": "Banana Robusta",
        "weight": "1kg",
        "price": "₹  60 / 1kg",
        "priceint": 60,
        "src": require("./Banana Robusta.webp")
        },
        {
        "name": "Orange Imported",
        "weight": "4pc",
        "price": "₹  92 / 4pc",
        "priceint": 92,
        "src": require("./Orange Imported.webp")
        },
        {
        "name": "Papaya(1pc) & Watermelon Kiran(1pc) Combo",
        "weight": "2 Combo",
        "price": "₹  172 / 2 Combo",
        "priceint": 172,
        "src": require("./Papaya(1pc) & Watermelon Kiran(1pc) Combo.webp"),
        },
        {
        "name": "Pomegranate",
        "weight": "4 pcs (Approx. 720g - 820g)",
        "price": "₹  228 / 4 pcs",
        "priceint": 228,
        "src": require("./Pomegranate.webp")
    },
    {
        "name": "Tender Coconut",
        "weight": "3pc",
        "price": "₹  195 / 3pc",
        "priceint": 195,
        "src": require("./Tender Coconut.webp"),
    },
    {
        "name": "Papaya Semi Ripe",
        "weight": "1 pc (Approx. 600g - 900g)",
        "price": "₹  65 / 600 g",
        "priceint": 65,
        "src": require("./Papaya Semi Ripe.webp"),
    },
    {
        "name": "Orange Baby",
        "weight": "500 g",
        "price": "₹  207 / 500 g",
        "priceint": 207,
        "src": require("./Orange Baby.webp"),
    },
    {
        "name": "Banana Yelakki (500gms) & Banana Robusta (500gms) Combo",
        "weight": "2 Combo",
        "price": "₹  78 / 2 Combo",
        "priceint": 78,
        "src": require("./Banana Yelakki (500gms) & Banana Robusta (500gms) Combo.webp"),
    },
    {
        "name": "Guava Indian Semi Ripe",
        "weight": "500 g",
        "price": "₹  86 / 500 g",
        "priceint": 86,
        "src": require("./Guava Indian Semi Ripe.webp"),
    },
    {
        "name": "Coconut",
        "weight": "1 pc (Approx. 500g - 700g)",
        "price": "₹  33 / 500g - 700g",
        "priceint": 33,
        "src": require("./Coconut.webp"),
    },
    {
        "name": "Banana Robusta Semi Ripe",
        "weight": "(Approx. 450g - 550g)",
        "price": "₹  30 / 500 g",
        "priceint": 30,
        "src": require("./Banana Robusta Semi Ripe.webp"),
    },
    {
        "name": "Apple Royal Gala",
        "weight": "4 pcs (500-600g)",
        "price": "₹  230 / 500 g",
        "priceint": 230,
        "src": require("./Apple Royal Gala.webp"),
    },
    {
        "name": "Banana Elaichi / Yelakki Semi Ripe",
        "weight": "500 g",
        "price": "₹  48 / 500 g",
        "priceint": 48,
        "src": require("./Banana Elaichi Yelakki Semi Ripe.webp"),
    },
    {
        "name": "Apple Pink Lady",
        "weight": "4pc",
        "price": "₹ 226 / 4pc",
        "priceint": 226,
        "src": require("./Apple Pink Lady.webp")
    },
    {
        "name": "Apple Red Delicious",
        "weight": "2 pcs (Approx. 280g - 300g)",
        "price": "₹ 105 / 300g",
        "priceint": 105,
        "src": require("./Apple Red Delicious.webp")
    },
    {
        "name": "Apple Royal Gala",
        "weight": "2 pcs (Approx. 280g - 300g)",
        "price": "₹ 108 / 300 g",
        "priceint": 108,
        "src": require("./Apple Royal Gala.webp")
    },
    {
        "name": "Kiwi Chile Semi Ripe",
        "weight": "3 piece",
        "price": "₹ 142 / 3 piece",
        "priceint": 142,
        "src": require("./Kiwi Chile Semi Ripe.webp")
    },
    {
        "name": "Pineapple Semi Ripe",
        "weight": "1 pc (Approx. 900g - 1.2 kg)",
        "price": "₹ 99 / 1 kg",
        "priceint": 99,
        "src": require("./Pineapple Semi Ripe.webp")
    },
    {
        "name": "Pomegranate",
        "weight": "2 pcs (Approx. 480g - 550g)",
        "price": "₹ 152 / 500 g",
        "priceint": 152,
        "src": require("./Pomegranate.webp")
    },
    {
        "name": "Watermelon Kiran",
        "weight": "1 pc (Approx. 2.2 - 3.5 kg)",
        "price": "₹ 107 / 1 pc (2.2 - 3.5 kg)",
        "priceint": 107,
        "src": require("./Watermelon Kiran.webp")
    },
    {
        "name": "Musk Melon (1pc) & Watermelon Kiran (1pc) Combo",
        "weight": "2 Combo",
        "price": "₹ 154 / 2 Combo",
        "priceint": 154,
        "src": require("./Musk Melon (1pc) & Watermelon Kiran (1pc) Combo.webp")
    },
    {
        "name": "Apple Green",
        "weight": "2 pcs (Approx. 260g - 300g)",
        "price": "₹ 121 / 300 g",
        "priceint": 121,
        "src": require("./Apple Green.webp")
    },
    {
        "name": "Dragon Fruit Imported",
        "weight": "1 pc (Approx. 300g)",
        "price": "₹ 140 / 1 pc ( 300g )",
        "priceint": 140,
        "src": require("./Dragon Fruit Imported.webp")
    }
]
        
        export default fruit;